import { cs } from "../../../../date-fns/locale/cs.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    cs
  }
};